import { render, staticRenderFns } from "./DefaultPaymentButton.vue?vue&type=template&id=a1c253e0&scoped=true&"
import script from "./DefaultPaymentButton.vue?vue&type=script&lang=js&"
export * from "./DefaultPaymentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c253e0",
  null
  
)

export default component.exports